import { IPost } from '_interfaces/post.interface';
import { selectedProjectAtom } from 'atoms/projects';
import { EventItem } from 'components/EventItem';
import FlagIcon from 'assets/icons/event-flag.svg';
import dayjs from 'dayjs';
import { useAtomValue } from 'jotai';
import React from 'react';
import { isScheduleItemPost } from 'utils/systemPostHelpers';

interface ScheduleItemPostProps {
  post: IPost;
  onClick?: () => void;
}

export const ScheduleItemPost: React.FC<ScheduleItemPostProps> = ({ post, onClick }) => {
  const project = useAtomValue(selectedProjectAtom);

  if (!post.systemMetadata || !isScheduleItemPost(post.systemMetadata)) {
    return null;
  }

  const { systemMetadata, createdAt } = post;
  const { linkData } = systemMetadata;
  const { scheduleName, scheduleItemId, itemValue } = linkData;

  let displayName = scheduleName;
  let displayPhase = itemValue;

  if (!displayName && scheduleItemId && project?.phases) {
    for (const phase of project.phases) {
      const item = phase.items?.find((i) => i.id?.toString() === scheduleItemId);
      if (item) {
        displayName = item.title;
        displayPhase = phase.name;
        break;
      }
    }
  }

  displayName = displayName || 'Schedule Item';
  displayPhase = displayPhase || '';

  const nameSplit = post.createdBy?.displayName?.split(' ');
  const firstName = nameSplit?.[0] || '';
  const lastName = nameSplit?.[1] || '';
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
  const text = 'added a comment';
  const date = `${dayjs(createdAt).format('ll')} / ${dayjs(createdAt).format('LT')}`;

  return (
    <EventItem.Root>
      <EventItem.Header
        firstName={firstName}
        lastName={lastName}
        initials={initials}
        date={date}
        avatar={post.createdBy?.avatarUrl}
        text={text}
      />
      <EventItem.Content>
        <EventItem.Row>
          <EventItem.Circle>
            <FlagIcon />
          </EventItem.Circle>
          <EventItem.Column>
            <EventItem.Text fontWeight={500} text={displayName} />
            {displayPhase && <EventItem.Text text={displayPhase} />}
          </EventItem.Column>
        </EventItem.Row>
        <EventItem.ActionButton onClick={onClick} />
      </EventItem.Content>
    </EventItem.Root>
  );
};
